// ============================================================
// Datei: src/pages/ressorts/infostand/Infostand.jsx
// 🔥 FIX:
// - reloadVolunteers abgesichert
// ============================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import Api from "../../../Api";

import InfostandDesktop from "./InfostandDesktop";
import InfostandMobile from "./InfostandMobile";
import useMediaQuery from "../../../hooks/useMediaQuery";

const Infostand = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	const volunteersHook = useVolunteers("Infostand");

	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];

	// 🔥 FIX: fallback wie bei allen anderen Ressorts
	const reloadVolunteers =
		typeof volunteersHook[2] === "function"
			? volunteersHook[2]
			: async () => {
				try {
					const res = await Api.get("/volunteers?department=Infostand");
					setVolunteers([...res.data]);
				} catch (err) {
					console.error("❌ Reload Volunteers Fehler:", err);
				}
			};

	const [shifts] = useShifts("Infostand");

	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "infostand") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		loadGuests();
	}, [navigate]);

	const loadGuests = () => {
		Api.get("/guests").then(res => setGuests(res.data));
	};

	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", {
				responseType: "blob"
			});

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			document.body.appendChild(a);
			a.click();
			a.remove();

			window.URL.revokeObjectURL(url);

		} catch (err) {
			console.error("CC-Download Fehler:", err);
			alert("Download fehlgeschlagen");
		}
	};

	const layoutProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers, // 🔥 wichtig
		shifts,
		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests: loadGuests,
		downloadCcEmails
	};

	return (
		<div
			className="infostand-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_infostand.jpg`}
		>
			<h2 className="infostand-heading">Infostand</h2>

			{isMobile
				? <InfostandMobile {...layoutProps} />
				: <InfostandDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Infostand;